import { JsonObject, JsonProperty } from 'json2typescript';
import { isUndefined } from 'util';

import { LearnCertClass } from './learn-cert-class';
import { LearnCertType } from './learn-cert-type';

@JsonObject
export class LearnCertEntry {
  @JsonProperty('idx', Number)
  idx: number = undefined;

  learnCertClass: LearnCertClass = undefined;

  learnCertType: LearnCertType = undefined;

  @JsonProperty('number', Number)
  number: number = undefined;

  @JsonProperty('classId', Number)
  classId: number = undefined;

  @JsonProperty('typeId', Number)
  typeId: number = undefined;

  isEmpty() {
    return isUndefined(this.idx) || isUndefined(this.number)
      || isUndefined(this.classId) || isUndefined(this.typeId);
  }
}
